import React from "react";
import AuthLayout from "./material/layouts/Auth";
import AdminLayout from "./material/layouts/Admin";
import { Switch, Route, Redirect } from "react-router-dom";
import MainLayout from "./layouts/Main.js";

import "./material/assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import ProtectedRoute from "./components/Auth/ProtectedRoute";

const App = props => {
  return (
    <Switch>
      <Route path="/material/auth" component={AuthLayout} />
      <Route path="/material/admin" component={AdminLayout} />
      <Redirect from="/material" exact to="/material/admin" />
      <ProtectedRoute path="/" component={MainLayout} />
    </Switch>
  );
};

export default App;
